<ts-admin-override-banner
  *ngIf="is_admin"
  [hide_admin_only]="true"
  [hide_review_toggles]="true"
  [select_all]="skip_all_overrides"
  [skip_approval]="skip_approval"
  [skip_policy_agreement]="skip_policy_agreement"
  [suppress_user_email]="suppress_user_email"
  [disabled]="toggle_controls_disabled"
  (emit_select_all_overrides)="toggleAllOverrides($event)"
  (emit_skip_approval)="toggleSkipApprovals($event)"
  (emit_skip_policy_agreement)="toggleSkipPolicyAgreement($event)"
  (emit_suppress_user_email)="toggleSupressUserEmail($event)"
/>

<div
  [tds-data-loader]="{
    key: 'order-fields',
    global: true
  }"
>
  <tds-notifications
    *ngFor="let item of notifications | keyvalue"
    [notifications]="item.value.notification_list"
    [notification_type]="item.value.type"
    [notification_icon]="item.value.icon"
    [notification_color]="item.value.color"
  />

  <ng-container *ngIf="order_id">
    <div class="row row-gap-3">
      <div class="col-12 col-lg-7">
        <ts-order-approvers
          [skip_approval]="skip_approval"
          (valid_approver_form)="approverFormIsValid($event)"
          (approval_notification)="approvalNotification($event)"
          (selected_approver_output)="setSelectedApprovers($event)"
        />

        <ts-order-details
          *ngIf="source_order_details"
          class="d-block mb-3"
          [is_review]="true"
          [order_id]="order_id"
          [order_type_id]="order_type_id"
          [price_summary]="price_summary"
          [asset_details]="asset_details"
          [source_order_details]="source_order_details"
          [additional_info]="additional_info"
        />

        <ts-custom-form [form]="form" [json_form_data]="json_form_data" />
      </div>

      <div class="col-12 col-lg-5 order-summary">
        <div
          [ts-sticky-observer]
          [class.order-summary--sticky]="price_summary && !price_summary.is_bulk_order"
          [class.bulk-order-summary--sticky]="price_summary && price_summary.is_bulk_order"
          [ngClass]="{
            'order-summary--sticky-top':
              source_order_details.order_initiator.id !== additional_info.contact_information.id &&
              !price_summary?.is_bulk_order
          }"
        >
          <div class="card shadow-sm mb-3">
            <div class="card-body">
              <h4 class="card-title mb-3">
                {{
                  (price_summary?.is_bulk_order ? 'bulk_order_summary' : 'order_summary')
                    | translate
                }}
              </h4>

              <ng-container *ngTemplateOutlet="alertsInfo" />

              <ng-container
                *ngIf="price_summary && price_summary.is_bulk_order; else nonBulkOrderSummary"
              >
                <table
                  *ngIf="price_summary.one_time_costs"
                  class="table-sm w-100"
                  [ngClass]="{ 'mb-4': price_summary.recurring_costs }"
                >
                  <thead>
                    <th scope="col" class="text-wrap h5 pb-2 fw-medium">
                      {{ 'one_time_costs' | translate }}
                      ({{ (isEmployeePayable() ? 'employee' : 'company') | translate }})
                    </th>
                    <th scope="col" class="text-end h5 pb-2 fw-medium">
                      {{ price_summary.total_one_time_cost }}
                    </th>
                  </thead>
                  <tbody class="table-group-divider border-light-subtle">
                    <tr *ngIf="price_summary.bulk_order_additional_info?.bulk_onetime_device">
                      <td>{{ 'total_device_cost' | translate }}</td>
                      <td class="text-end">
                        <span
                          *ngIf="isEmployeePayable('device')"
                          class="material-icons-outlined pe-2 card-icon cursor-default"
                          placement="top"
                          ngbTooltip="{{ 'employee_cost' | translate }}"
                        >
                          credit_card
                        </span>
                        {{
                          price_summary.bulk_order_additional_info?.bulk_onetime_device
                            ?.total_cost_to_currency
                        }}
                      </td>
                    </tr>
                    <tr *ngIf="bulk_accessories_length">
                      <td>{{ 'total_add_ons_cost' | translate }}</td>
                      <td class="text-end">
                        <span
                          *ngIf="isEmployeePayable('addon')"
                          class="material-icons-outlined pe-2 card-icon cursor-default"
                          placement="top"
                          ngbTooltip="{{ 'employee_cost' | translate }}"
                        >
                          credit_card
                        </span>
                        {{ price_summary.bulk_order_additional_info?.bulk_total_accessories_cost }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table *ngIf="price_summary.recurring_costs" class="table-sm w-100">
                  <thead>
                    <th scope="col" class="h5 pb-2 fw-medium">
                      {{ 'recurring_costs' | translate }} ({{ 'company' | translate }})
                    </th>
                    <th scope="col" class="text-end h5 pb-2 fw-medium">
                      {{ price_summary.total_recurring_cost }}/mo.
                    </th>
                  </thead>
                  <tbody class="table-group-divider border-light-subtle">
                    <tr
                      *ngIf="
                        price_summary.bulk_order_additional_info?.cost_per_bundle
                          ?.recurring_device_cost &&
                        price_summary.bulk_order_additional_info?.bulk_recurring_device
                      "
                    >
                      <td>{{ 'total_device_cost' | translate }}</td>
                      <td class="text-end">
                        {{
                          price_summary.bulk_order_additional_info?.bulk_recurring_device
                            ?.total_cost_to_currency
                        }}/mo.
                      </td>
                    </tr>
                    <tr *ngIf="price_summary.bulk_order_additional_info?.bulk_plan">
                      <td>{{ 'total_plan_cost' | translate }}</td>
                      <td class="text-end">
                        {{
                          price_summary.bulk_order_additional_info?.bulk_plan
                            ?.total_cost_to_currency
                        }}/mo.
                      </td>
                    </tr>
                    <tr *ngIf="bulk_features_length">
                      <td>{{ 'total_feature_cost' | translate }}</td>
                      <td class="text-end">
                        {{ price_summary.bulk_order_additional_info?.bulk_total_features_cost }}/mo.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <ng-template #nonBulkOrderSummary>
                <table
                  *ngIf="price_summary && price_summary.one_time_costs"
                  class="table table-sm non-table"
                  [ngClass]="{ 'mb-4': price_summary && price_summary.recurring_costs }"
                >
                  <thead>
                    <th scope="col" class="text-wrap h5 pb-2">
                      {{ 'one_time_costs' | translate }}
                      ({{ (isEmployeePayable() ? 'employee' : 'company') | translate }})
                    </th>
                    <th scope="col" class="text-end h5 pb-2 fw-medium">
                      {{ price_summary.total_one_time_cost }}
                    </th>
                  </thead>

                  <tbody class="table-group-divider border-light-subtle">
                    <tr *ngFor="let item of price_summary.one_time_costs; let last = last">
                      <td class="w-100" [ngClass]="{ 'border-bottom-0': last }">
                        {{ item.name }} - {{ item.description }} (x{{
                          item.quantity | number: '1.0-0'
                        }}) &#64;
                        {{ item.cost_to_currency }}

                        <div *ngIf="item?.additional_info?.option">
                          ({{ 'option' | translate }}: {{ item?.additional_info?.option }})
                        </div>
                      </td>
                      <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': last }">
                        <span
                          *ngIf="
                            item.employee_cost_to_currency && (item.type == 'ACCESSORY' || 'DEVICE')
                          "
                          class="material-icons-outlined pe-2 card-icon cursor-default"
                          placement="top"
                          ngbTooltip="{{ 'employee_cost' | translate }}"
                        >
                          credit_card
                        </span>
                        {{ item.total_cost_to_currency }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  *ngIf="price_summary && price_summary.recurring_costs"
                  class="table table-sm mb-0 non-table"
                >
                  <thead>
                    <th scope="col" class="text-wrap h5 pb-2">
                      {{ 'recurring_costs' | translate }} ({{ 'company' | translate }})
                    </th>
                    <th scope="col" class="text-end h5 pb-2">
                      {{ price_summary.total_recurring_cost }}/mo.
                    </th>
                  </thead>

                  <tbody class="table-group-divider border-light-subtle">
                    <tr *ngFor="let item of price_summary!.recurring_costs; let last = last">
                      <td class="w-100" [ngClass]="{ 'border-bottom-0': last }">
                        {{ item.name }}
                        <span *ngIf="item?.included">({{ 'included' | translate }})</span>
                        <span *ngIf="item?.additional_info?.unchanged">
                          ({{ 'unchanged' | translate }})
                        </span>
                      </td>
                      <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': last }">
                        <span *ngIf="getFeatureType(item)" class="pe-1">
                          <span
                            class="d-inline-flex"
                            [class.themed-badge-success]="item.sub_type === 'ADDED_FEATURE'"
                            [class.themed-badge-danger]="item.sub_type === 'REMOVED_FEATURE'"
                          >
                            ({{ getFeatureType(item) }})
                          </span>
                        </span>
                        <span
                          [class.text-decoration-line-through]="item.sub_type === 'REMOVED_FEATURE'"
                        >
                          {{ item.total_cost_to_currency }}/mo.
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div *ngIf="!hide_price_content">
                  <div *ngIf="order_type_id === 13" class="pb-3">
                    {{ 'transfer_details_review_summary' | translate }}
                  </div>
                  <div class="pb-3">{{ 'review_order_details' | translate }}:</div>

                  <strong>
                    {{ source_order_details.source_order_type }}:

                    <ng-container [ngSwitch]="order_type_id">
                      <span *ngSwitchCase="9">
                        {{ asset_details.existing_asset.device.manufacturer }}
                        {{ asset_details.existing_asset.device.model }}
                        <span *ngIf="asset_details.existing_asset.device.imei">
                          ({{ asset_details.existing_asset.device.imei }})
                        </span>
                      </span>

                      <span *ngSwitchCase="!existing_asset?.asset_from_inventory && 6">
                        {{ 'no_company_device' | translate }}
                      </span>

                      <span *ngSwitchDefault>
                        <ng-container *ngIf="existing_asset && existing_asset.line">
                          {{ existing_asset.line.international_number }}
                        </ng-container>
                      </span>
                    </ng-container>
                  </strong>
                </div>

                <div *ngIf="[19].includes(order_type_id)">
                  <div class="row flex-column">
                    <div class="col mb-3">
                      <span>
                        {{ 'review_complete_details_for' | translate }}
                      </span>
                    </div>
                    <div class="col">
                      <span class="fw-normal">
                        {{ 'line_input' | translate: existing_asset.line.international_number }}
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="card-footer py-3 border-top-0">
              <div
                *ngIf="
                  hide_price_content &&
                  isEmployeePayable() &&
                  price_summary?.total_features_recurring_cost?.price
                    ?.difference_cost_to_currency_in_cents != 0
                "
                class="h5 mb-3"
              >
                <span> {{ 'total_employee_costs' | translate }} </span>
                <span class="h5 float-end">
                  {{
                    price_summary?.is_bulk_order
                      ? source_order_details.payment_details.bulk_cost_to_card
                      : source_order_details.payment_details.cost_to_card
                  }}
                </span>
              </div>

              <div *ngIf="price_summary && is_total_recurring_cost" class="h5 mb-3">
                <span> {{ 'total_company_costs' | translate }} </span>
                <span class="h5 float-end"> {{ price_summary.total_recurring_cost }}/mo. </span>
              </div>

              <div *ngIf="hide_price_content && footer_hint" class="d-block mb-3">
                <span>
                  {{ footer_hint }}
                </span>
              </div>

              <button
                type="button"
                class="btn btn-success w-100"
                [disabled]="disable_order_submit"
                (click)="validateReviewFields()"
              >
                {{ 'submit_order' | translate }}
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col d-flex flex-column align-items-center">
              <button type="button" class="btn btn-danger px-md-4" (click)="cancelOrder()">
                {{ 'cancel_order' | translate }}
              </button>
              <span class="pt-3"> {{ cancel_order_hint }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #alertsInfo>
  <div *ngIf="order_type_id === 12" class="alert alert-primary" role="alert">
    <span>
      {{ 'previous_recurring_cost' | translate }}
      {{ existing_asset.line.price?.cost_to_currency }}/mo.
    </span>
  </div>
</ng-template>
